import api from "../..";
import type { Banner, GetBannerByIdParams } from "./types";
import type { ApiResponse } from "../../types";

export const getBanner = async (): Promise<Banner[]> => {

  return await api.get<ApiResponse<Banner[]>>("admin/banner/")
  .then(res => res.data.data)
  .catch(() => {return []});
};

export const getBannerById = async ({ uuid }: GetBannerByIdParams): Promise<Banner | null> => {

  return await api.get<ApiResponse<Banner>>(`admin/banner/${uuid}/`)
  .then(res => res.data.data)
  .catch(() => {return null});
};